import type { FrontendWidget } from '../types';
import { CollapsibleWidgetComponent } from './CollapsibleWidgetComponent';
import { CollapsibleWidgetComponentB } from './CollapsibleWidgetComponentB';
import { CollapsibleWidgetComponentC } from './CollapsibleWidgetComponentC';
import type {
  CollapsibleWidgetConfig,
  CollapsibleWidgetResolved,
} from './types';

export const collapsibleWidget: FrontendWidget<
  CollapsibleWidgetConfig,
  CollapsibleWidgetResolved
> = {
  componentType: 'widgets.collapsible-widget',
  displayName: 'Collapsible Widget',
  ComponentA: CollapsibleWidgetComponent,
  ComponentB: CollapsibleWidgetComponentB,
  ComponentC: CollapsibleWidgetComponentC,
  resolveSync: (config) => config,
};
